import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form";
import { InwardAccepted, InwardEdit } from "../../utils/apis/Inward/Inward";
import { Context } from "../../utils/context";
import Select from "react-select";
import { kycStatus } from "../../utils/apis/Investores/Investores";
import Col from "react-bootstrap/Col";

import Row from "react-bootstrap/Row";
import { formatDate } from "../../utils/common";
import { error } from "jquery";

const BankHistoryModal = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setError,
    setValue,
    control,
    reset,
  } = useForm();

  const options = [
    { value: "Accepted", label: "Accepted" },
    { value: "Rejected", label: "Rejected" },
  ];

  const [reasonShow, setReasonShow] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const { IMG_URL } = useContext(Context);

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
  }

  return (
    <>
      <Modal
        {...props}
        size="xl"
        className="Payment_Screenshotmodal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Bank History Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead className="table-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Date</th>
                  <th scope="col">Bank Account No.</th>
                  <th scope="col">Bank Account Name</th>
                  <th scope="col">IFSC Code</th>
                  <th scope="col">Bank Name</th>
                  <th scope="col">Account Type</th>
                </tr>
              </thead>
              <tbody>
                {props?.bankHistory &&
                  props?.bankHistory.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{formatDate(item.createdAt)}</td>
                      <td>{item.ac_no}</td>
                      <td>{item.holder_name}</td>
                      <td>{item.ifsc_code}</td>
                      <td>{item.bank_name}</td>
                      <td>{item.account_type}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BankHistoryModal;
